/* Route public-API calls through the Cloudflare function to avoid CORS. */
export const API_PROXY = "/api/proxy?url=";
export function px(u){ return API_PROXY + encodeURIComponent(u); }

export const uid=()=>Math.random().toString(36).slice(2,9);
export const fmt=(n,d=0)=>(isFinite(+n)?+n:0).toLocaleString("en-US",{style:"currency",currency:"USD",maximumFractionDigits:d,minimumFractionDigits:d});
export const num=v=>{const n=typeof v==="number"?v:parseFloat(String(v??"").replace(/[^0-9.-]/g,""));return isFinite(n)?n:0;};
export const seed=(s,o=0)=>{let h=2166136261;for(let i=0;i<s.length;i++)h=Math.imul(h^s.charCodeAt(i),16777619);h=Math.imul(h^o,2654435761);return(h>>>0)/4294967295;};
export const daysUntil=d=>d?Math.ceil((new Date(d)-new Date())/86400000):null;
export const day=n=>new Date(Date.now()+86400000*n).toISOString().slice(0,10);

// Shared by every "Go live" contextual prompt (EnrichPanel, ClydePanel,
// DealerFinder, the Add Vehicle button) — same POST /api/request-full-
// access call in all four places, previously a mailto: link in each.
// Only the network call is shared; each caller keeps its own local
// busy/sent UI state, since the four sites have nothing else in common
// (different themes, different surrounding component state).
export async function requestFullAccess(){
  try{
    const res=await fetch("/api/request-full-access",{method:"POST"});
    return res.ok;
  }catch{
    return false;
  }
}
